import _ from 'lodash';
import $cookie from 'vue-cookie';

export const lsStorageServiceConstants = {
    AUTH_TOKEN: 'auth.token',
    NOTIFICATION_EMAIL: 'notification.email',
    NOTIFICATION_PASSWORD: 'notification.password',
    REACTIVATION_DEAL: 'reactivation.deal',
    REACTIVATION_DEAL_STORED_AT: 'reactivation.deal.stored.at',
    SHARE_NEXTDOOR: 'share.nextdoor',
    SHARE_GOOGLE: 'share.google',
    SHARE_FACEBOOK: 'share.facebook',
    SHARE_TWITTER: 'share.twitter',
    SHARE_SMS: 'share.sms',
    SHARE_LINK: 'share.link',
    SHARE_EMAIL: 'share.email',
};

export const lsStorageService = {
    _private: {
        fallbackMemoryStorage: {},
        localStorageSupported: false,
        cookiesSupported: false,
        initialized: false,
    },

    init() {
        if (this._private.initialized) {
            return;
        }

        this._private.localStorageSupported = this.checkLocalStorageSupport();
        this._private.cookiesSupported = this.checkCookieSupport();
        this._private.initialized = true;
    },

    get(key) {
        this.init();

        // use js object -> cookie -> local storage, with local storage as highest priority if available
        let value = this.getFromFallbackMemoryStorage(key);
        if (this._private.cookiesSupported) {
            value = this.getFromCookies(key);
        }

        if (this._private.localStorageSupported) {
            value = this.getFromLocalStorage(key);
        }

        return value;
    },

    set(key, value) {
        this.init();
        if (this._private.localStorageSupported) {
            window.localStorage.setItem(key, JSON.stringify(value));
        }
        if (this._private.cookiesSupported) {
            // 6month expiration on cookies
            $cookie.set(key, JSON.stringify(value), { expires: '6M', domain: 'lawnstarter.com' });
        }

        this._private.fallbackMemoryStorage[key] = JSON.stringify(value);
    },

    clear(keys) {
        this.init();
        _.forEach(keys, (key) => {
            this.remove(key);
        });
    },

    remove(key) {
        this.init();
        if (this._private.localStorageSupported) {
            window.localStorage.removeItem(key);
        }
        if (this._private.cookiesSupported) {
            $cookie.delete(key, { domain: 'lawnstarter.com' });
        }

        delete this._private.fallbackMemoryStorage[key];
    },

    checkLocalStorageSupport() {
        const ls = 'LawnStarter';
        let itemStoredProperly = false;
        try {
            window.localStorage.setItem(ls, ls);
            itemStoredProperly = window.localStorage.getItem(ls) === ls;
            window.localStorage.removeItem(ls);

            return itemStoredProperly;
        } catch (e) {
            return false;
        }
    },

    checkCookieSupport() {
        const ls = 'LawnStarter';
        let itemStoredProperly = false;
        try {
            $cookie.set(ls, ls);
            itemStoredProperly = $cookie.get(ls) === ls;
            $cookie.delete(ls);
            return itemStoredProperly;
        } catch (e) {
            return false;
        }
    },

    getFromLocalStorage(key) {
        let value = null;
        try {
            value = JSON.parse(window.localStorage.getItem(key));
        } catch (e) {
            value = window.localStorage.getItem(key);
        }
        return value;
    },

    getFromCookies(key) {
        let value = null;
        try {
            value = JSON.parse($cookie.get(key));
        } catch (e) {
            value = $cookie.get(key);
        }
        return value;
    },

    getFromFallbackMemoryStorage(key) {
        let value = null;
        try {
            value = JSON.parse(this._private.fallbackMemoryStorage[key]);
        } catch (e) {
            value = this._private.fallbackMemoryStorage[key];
        }
        return value;
    },
};
